var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useCallback } from 'react';
import { RequireNewPassword, VerifyContact, withAuthenticator } from "aws-amplify-react";
import SignInComponent from "./SignInComponent";
import SignUpComponent from "./SignUpComponent";
import SignUpCompletionComponent from "./SignUpCompletionComponent";
import SignupConfirmationComponent from "./SignUpConfirmationComponent";
import Auth from "@aws-amplify/auth";
import OverwritingIntlProvider from "../Localization/OverwritingIntlProvider";
import ADFSLoginHelper from "./ADFSLoginHelper";
export var withLogin = function (loginConfigProps) { return function (Component) { return function () {
    var signOut = useCallback(function () {
        Auth.signOut()
            .then(function (data) { return data && console.log(data); }) //ToDo: remove console.log
            .catch(function (err) { return console.error(err); });
    }, []);
    var adfsUrl = loginConfigProps.cognitoUrl + "/oauth2/authorize?response_type=code&" +
        ("client_id=" + loginConfigProps.clientId + "&redirect_uri=" + loginConfigProps.redirectUri + "&") +
        ("identity_provider=" + loginConfigProps.adfsIdentityProvider);
    // @ts-ignore
    var WithAuth = withAuthenticator(function () { return React.createElement(Component, { signOut: signOut }); }, true, [
        React.createElement(SignInComponent
        // @ts-ignore due to injectIntl messing up component signatures
        , { 
            // @ts-ignore due to injectIntl messing up component signatures
            adminsOnly: loginConfigProps.adminsOnly, requireAcl: loginConfigProps.requireAcl, adfs_url: adfsUrl }),
        React.createElement(SignUpComponent, null),
        React.createElement(SignUpCompletionComponent, null),
        React.createElement(VerifyContact, null),
        React.createElement(RequireNewPassword, null),
        React.createElement(SignupConfirmationComponent, null)
    ], true);
    return (React.createElement(OverwritingIntlProvider, { localeOverwrite: loginConfigProps.locale, messagesOverwrite: loginConfigProps.messages },
        React.createElement(ADFSLoginHelper, __assign({}, loginConfigProps),
            React.createElement(WithAuth, null))));
}; }; };
//# sourceMappingURL=withLogin.js.map